exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.bss-pager-wrap[data-v-1411dcd6] {\n  display: inline-block;\n}\n.bss-pager-wrap .el-input__inner[data-v-1411dcd6] {\n    text-align: center;\n}\n", "", {"version":3,"sources":["/data/node_workspace_2_15/workspace/uat-deploy-erp-frontproject/src/layout/pages/home/bss-pager/index.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;CACvB;AACD;IACI,mBAAmB;CACtB","file":"index.vue","sourcesContent":["\n.bss-pager-wrap[data-v-1411dcd6] {\n  display: inline-block;\n}\n.bss-pager-wrap .el-input__inner[data-v-1411dcd6] {\n    text-align: center;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1411dcd6","scoped":true,"hasInlineConfig":false}!./node_modules/fast-sass-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layout/pages/home/bss-pager/index.vue
// module id = n44z
// module chunks = 6